import { Injectable } from '@angular/core';
import imageCompression from 'browser-image-compression';

@Injectable()
export class Compress {

    constructor() { }

    static compressImage(file: File): Promise<File> {

      const options = {
        maxSizeMB: 4,
        maxWidthOrHeight: 500,
      }
    
      return imageCompression(file, options);
    }

}

